import {
  MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN,
  MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER,
} from "./MOCK_DATA";

export const getPreSubscriptionData = (useMockData = false, mockType?: "default" | "noOffer" | "noCountdown") => {
  if (useMockData) {
    switch (mockType) {
      case "default":
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_DEFAULT) });
      case "noOffer": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_OFFER) });
      }
      case "noCountdown": {
        return Promise.resolve({ json: () => Promise.resolve(MOCK_DATA_PRE_SUBSCRIPTION_NO_COUNTDOWN) });
      }
    }
  }
  return fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/app/GetPreSubscriptionModal`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
